import type {MembershipExpandedCommon} from '../../../../api/membership';
import type {ProgramApiModel} from '../../../../api/program';

import {inviteSend} from '../../invite/invite.send';
import {AcceptRequestedMembershipsStrategy} from './AcceptRequestedMembershipsStrategy';

type Config = {
  memberships: MembershipExpandedCommon[];
  target: ProgramApiModel;
};

export class InviteToAnotherProgramStrategy extends AcceptRequestedMembershipsStrategy {
  constructor(private readonly config: Config) {
    super();
  }

  async execute(): Promise<void> {
    const {memberships, target} = this.config;

    await this.decline(memberships);

    await inviteSend.asCoach({
      params: {recipients: memberships.map(({user_id}) => ({user_id}))},
      showSuccessMessage: false,
      target,
    });
  }
}
